<template>
    <v-container :class="{'pa-0': $vuetify.breakpoint.smAndDown, 'px-5 py-5': $vuetify.breakpoint.mdAndUp}">
        <div style="height: 35px;">
            </div>
             <v-flex xs12 sm6 md4 style="margin: auto;">
                <h1 style="font-size: 20px;  color: #1f97b9;">Hola</h1>
                    
                    <h1 style="font-size: 20px;  color: #1f97b9;" > ¿Cuál es su nombre?</h1>
                <v-text-field label
                class="pointer"
                v-model="datos.personales.nombre"
                color="#1f97b9"
                ></v-text-field>
                <div>
                    <v-btn @click="validate(true)" style="background-color: #1f97b9; color: #FFFFFF;">Continuemos</v-btn>
                </div>
             </v-flex>
    </v-container>
</template>

<script>
import { EventBus } from '../../../events.js'
export default {
    name: 'nombreExpress',
    data () {
        return {
            datos: {
                personales: {
						//nombre: 'asdasdasd', este era el original
                        nombre: '',
						telefono: '',
						email: ''
					},
                date: '',
                time: '',
                direccion_origen:{
                    direccion: "",
                    marker: {},
                    direccion_obj: {},
                    estacionamiento: ''
                },
                direccion_destino:{
                    direccion: "",
                    marker: {},
                    direccion_obj: {},
                    estacionamiento: ''
                },
                oferta:{
                }
            }
        }
    },
    methods: {
        eventTracker(tipo) {
            gtag('event', tipo, {
            'event_category' : tipo,
            'event_label' : tipo
            })
        },
        validate(move) {
            
            if (this.datos.personales.nombre !== '') {
                var data = {
                    datos: this.datos,
                    valid: true,
                    move
                    
                }
                
                if(move){
                    this.eventTracker('cotizacionExpressFirst')
                    EventBus.$emit('mudanzaExpressFirst', data);
                }
            }
            
        },
    }
}
</script>